import Component from "../../components/VideoCallRating/VideoCallRating";
import {useState} from "preact/hooks";

const VideoCallRating = ({ onSubmit }) => {
  const [serviceRating, setServiceRating] = useState(-1);
  const [videoRating, setVideoRating] = useState(-1);

  return <Component
    onChangeServiceRating={setServiceRating}
    onChangeVideoRating={setVideoRating}
    videoRating={videoRating}
    serviceRating={serviceRating}
    onSubmit={onSubmit}
  />;
};

export default VideoCallRating;



// WEBPACK FOOTER //
// ./containers/VideoCallRating/VideoCallRating.js